import { api } from './client.js';

export const sitesApi = {
  list: (workspaceId) =>
    api.get(`/workspaces/${workspaceId}/sites`).then((r) => r.data.sites),
  create: (workspaceId, payload) =>
    api.post(`/workspaces/${workspaceId}/sites`, payload).then((r) => r.data.site),
  show: (siteId) => api.get(`/sites/${siteId}`).then((r) => r.data.site),
  update: (siteId, payload) => api.patch(`/sites/${siteId}`, payload).then((r) => r.data.site),
  destroy: (siteId) => api.delete(`/sites/${siteId}`).then((r) => r.data),
};

export const pagesApi = {
  list: (siteId) => api.get(`/sites/${siteId}/pages`).then((r) => r.data.pages),
  create: (siteId, payload) =>
    api.post(`/sites/${siteId}/pages`, payload).then((r) => r.data.page),
  show: (pageId) => api.get(`/pages/${pageId}`).then((r) => r.data),
  update: (pageId, payload) => api.patch(`/pages/${pageId}`, payload).then((r) => r.data.page),
  publish: (pageId) => api.post(`/pages/${pageId}/publish`).then((r) => r.data.page),
  versions: (pageId) => api.get(`/pages/${pageId}/versions`).then((r) => r.data.versions),
  destroy: (pageId) => api.delete(`/pages/${pageId}`).then((r) => r.data),
};
